import { forwardRef } from 'react';
import { Link as RouterLink, LinkProps } from 'react-router-dom';
import { useLanguage } from '@/contexts/language/LanguageContext';

// Drop-in replacement for react-router's <Link>: on a Slovak page, internal links
// point at the /sk twin of the target page when one exists.
export const Link = forwardRef<HTMLAnchorElement, LinkProps>(({ to, ...props }, ref) => {
  const { localizePath } = useLanguage();
  return <RouterLink ref={ref} to={typeof to === 'string' ? localizePath(to) : to} {...props} />;
});

Link.displayName = 'LocaleLink';

export default Link;
